import React from 'react';
import ReactDOM from 'react-dom/client';
// Amplify / Cognito の初期化（全コンポーネントより先に実行する）
import './cognitoClient';
import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';
import { MantineProvider, ColorSchemeScript } from '@mantine/core';
import { theme, cssVariablesResolver } from './theme';
import { BrowserRouter } from 'react-router-dom';
import '@mantine/core/styles.css';
import './question-html.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ColorSchemeScript defaultColorScheme="auto" />
    <MantineProvider defaultColorScheme="auto" theme={theme} cssVariablesResolver={cssVariablesResolver}>
      <BrowserRouter>
        <AppWrapper />
      </BrowserRouter>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
